module.exports = "<span ng-class=\"{'control-label fontNormal': vm.allDaily == true}\" ng-bind=\"vm.activeTime\"></span>";


//////////////////
// WEBPACK FOOTER
// ./src/app.retailer.common/components/campaign-active-time/campaign-active-time.html
// module id = 24
// module chunks = 0 1 3 4